import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Html5QrcodeComponent, QrScanResult } from '../html5-qrcode-reader/html5-qrcode-reader.component';
import { TimeInterval, TimeoutError } from 'rxjs';
import { QrcodeResultFormat } from 'html5-qrcode/esm/core';

@Component({
  selector: 'app-qr-or-scanner-reader',
  templateUrl: './qr-or-scanner-reader.component.html',
  styleUrls: ['./qr-or-scanner-reader.component.scss'], 
})
export class QrOrScannerReaderComponent {
  
  @Input() showCamRef: boolean = false;
  @Output() scanCanceled = new EventEmitter<void>();
  @Output() scanSuccess = new EventEmitter<QrScanResult>();
  @Output() onCameraInit = new EventEmitter<QrScanResult>();

  public readedKeyboardString: string = "";

  public successScan($event: QrScanResult){
    this.scanSuccess.emit($event);
  }

  public cameraInit(){
    this.onCameraInit.emit();
  }

  @HostListener('window:keydown',['$event'])
  onKeyDown($event) {
    if($event.key == "Tab"){
      $event.stopImmediatePropagation();
      return false;
    }
  }

  @HostListener('window:keypress',['$event'])
  onKeyPress($event) {
    if(($event.key == "Enter") || ($event.key == "Tab")){
      this.scanSuccess.emit({decodedText: this.readedKeyboardString, decodedResult: {type: "scanner"}});
      this.readedKeyboardString = "";

      $event.stopImmediatePropagation();
      return false;
    }
    else{
      let keyboardKey: string = $event.code;


      //этот код решает проблему раскладки клавиатуры, если сканировать сканером код на русской раскладке, то вместо английских символов будут русские
      if(keyboardKey.indexOf("Key") === 0){
        this.readedKeyboardString += keyboardKey.replace("Key", "").toLowerCase();
      }
      else
      if(keyboardKey.indexOf("Digit") === 0){
        this.readedKeyboardString += keyboardKey.replace("Digit", "").toLowerCase();
      }
      else
      if(keyboardKey.indexOf("Numpad") === 0){
        this.readedKeyboardString += keyboardKey.replace("Numpad", "").toLowerCase();
      }
      if(keyboardKey.indexOf("Space") === 0){
        this.readedKeyboardString += " ";
      }
    }
  }
}
